import HeroLayout5 from "components/common/hero/HeroLayout5";
import GlobalLayout from "components/page/GlobalLayout";
import RetailLeaders from "components/retail-security-checklist/RetailLeaders";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";

const RetailSecurityChecklist = () => {
  const imageData = useStaticQuery(graphql`
    query {
      hero: file(
        relativePath: {
          eq: "components/retail-security-checklist/assets/retail-security-checklist-hero.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, quality: 100)
        }
      }
    }
  `);

  return (
    <GlobalLayout color="var(--secondary-bg)">
      <Helmet>
        <title>
          Evaluate Your Retail Operations | Retail Security Checklist | Rhombus
        </title>
        <meta
          name="description"
          content="Secure your store from theft and disruptions with Rhombus' retail security checklist. Identify critical vulnerabilities, streamline operations, and implement proven solutions trusted by top retailers."
        />
      </Helmet>
      <HeroLayout5
        formTitle={"Download the Checklist"}
        formId={"b2d7a8a9-021c-4ec8-a704-4f91c0857370"}
        image={imageData.hero}
        title={"Retail Security Checklist"}
        blurb={
          <>
            <span>Secure your retail operations with confidence.</span>
            <br></br> <br></br>Protect your stores from theft and operational
            disruptions with Rhombus' comprehensive retail security checklist.
            Identify critical vulnerabilities, streamline operations, and
            implement proven solutions trusted by leading retailers.
          </>
        }
      />
      <RetailLeaders />
    </GlobalLayout>
  );
};

export default RetailSecurityChecklist;
